import React, { useState, useEffect, useMemo, useContext } from "react"
import { useNavigate } from "react-router-dom"
import debounce from "lodash.debounce";
import axios from 'axios';
import { X_TENANT_ID, SEARCHPRODUCT } from '../../../common/ActionUrl';
import { _useToasts } from "../../../common/_useToasts";
import { productPath } from "../../../util/helper";
import { AuthContext } from "../../../common/Auth";

const MobileSearch = () => {
    const navigate = useNavigate()
    const [productNameList, setProductNameList] = useState([])
    const [productCatList, setProductCatList] = useState([])
    const [productTagList, setproductTagList] = useState([])
    const [tempValue, setTempValue] = useState(false)
    const { _addToast } = _useToasts();
    const { user} = useContext(AuthContext)
    const userId = user?.userId

    const getProducts = (searchValue = "") => {

        const requestOptions = {
            headers: { 'X-TENANT-ID': X_TENANT_ID },
        }
        if (searchValue != "" && searchValue != "undefined" && searchValue != undefined) {
            let url = SEARCHPRODUCT + `?productName=${searchValue}&user=${ userId ?? '' }`
            axios.get(url, requestOptions)
                .then(async res => {
                    setTempValue(!tempValue)
                    if (res.data.error) {
                        _addToast(res.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        })
                    } else {
                        setProductNameList(res.data.products)
                        setProductCatList(res.data.categories)
                        setproductTagList(res.data.tags)
                    }
                })
                .catch(err => {
                    console.log('err', err)
                })
        } else {
            setProductNameList([])
            setProductCatList([])
            setproductTagList([])
        }
    }

    const inputChange = (e) => {

        getProducts(e.target.value)
    }

    const debouncedChangeHandler = useMemo(
        () => debounce(inputChange, 300)
        , []);

    useEffect(() => {
        return () => {
            debouncedChangeHandler.cancel();
        }
    }, []);

    const goToProduct = (e, product) => {
        localStorage.removeItem('catTree')
        document.getElementById("mobile-menu-close-trigger").click();
        navigate(process.env.PUBLIC_URL + "/product/" + productPath(product))
    }
    const goToTagProduct = (e, tag) => {
        document.getElementById("mobile-menu-close-trigger").click();
        navigate(process.env.PUBLIC_URL + "/products?tag=" + tag)
    }
    const goToCatProduct = (e, category) => {
        document.getElementById("mobile-menu-close-trigger").click();
        navigate(process.env.PUBLIC_URL + "/products?category=" + category)
    }

    return (
        <>
            <div className="offcanvas-mobile-search-area">
                <form>
                    <div className="d-flex row col-md-12 input-box align-items-center mb-5">
                        <input
                            id="combo-box-demo-mobile"
                            onChange={debouncedChangeHandler}
                            type="text"
                            placeholder="Search Product"
                            autoComplete="off"
                        />
                        <button className="button-search" onClick={(event) => {
                            event.preventDefault()

                        }}>
                            <i className="pe-7s-search" />
                        </button>
                    </div>
                    {tempValue && (
                        <div className="productSearchList d-flex row col-md-12 input-box align-items-center p-0 m-0">

                            {productNameList.length > 0 && (
                                <>
                                    <div className="w-100 m-0">
                                        <h4 className="f-w-600 pl-1">Products</h4>
                                        <ul>
                                            {productNameList.map((data, index) => (
                                                <li className="ml-3" key={data.id} onClick={(event) => {
                                                    event.preventDefault()
                                                    goToProduct(event, data)
                                                }}>
                                                    {data.productName}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </>
                            )}

                            {productCatList.length > 0 && (
                                <>
                                    <div className="w-100 m-0">
                                        <h4 className="f-w-600 pl-1">Categories</h4>
                                        <ul>
                                            {productCatList.map((data, index) => (
                                                <li className="ml-3" key={data.id} onClick={(event) => {
                                                    event.preventDefault()
                                                    goToCatProduct(event, data.categoryName)
                                                }}>
                                                    {data.categoryName}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </>

                            )}
                            {productTagList.length > 0 && (
                                <>
                                    <div className="w-100 m-0">
                                        <h4 className="f-w-600 pl-1">Tags</h4>
                                        <ul>
                                            {productTagList.map((data, index) => (
                                                <li className="ml-3" key={data.id} onClick={(event) => {
                                                    event.preventDefault()
                                                    goToTagProduct(event, data.tagName)
                                                }}>
                                                    {data.tagName}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </>
                            )}

                        </div>)}
                </form>
            </div>
        </>
    )
}

export default MobileSearch
